import { IBanner, IBannerItem, ICommunityImageBannerConfig } from '../interface/ICommunityImageBanner';
import axios from 'axios';
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { checkIsPurple, checkIsCommunitySdk } from '../common/Utils';

const MOBILE_BREAKPOINT = 960;
const LOCAL_HOSTS = ['', 'localhost', '127.0.0.1'];

export default class Index {
    constructor(_config: ICommunityImageBannerConfig) {
        // console.log('------- top Image Banner START-------', _config);

        this._init(_config)
    }

    _init(_config: ICommunityImageBannerConfig){
        // 퍼플인 경우 배너 출력 안함
        if(checkIsPurple() || checkIsCommunitySdk()){
            return;
        }

        const isLocalhost = LOCAL_HOSTS.includes(location.hostname);
        if (isLocalhost) {
            this._fetchDummyList(_config.dummyData as IBanner);
        } else {
            this.fetchBannerList(_config.apiDomain + _config.contiCommunityImageBannerApi);
        }
    }

    // 더미 데이터 가져오기
    _fetchDummyList(data: IBanner) {
        if (!data.isActive) return;
        this.createBanner(data.bannerList, data.bannerTitle);
    }

    async fetchBannerList(_api: string) {
        try {
            const { data } = await axios.get(`${_api}`);
            if (!data) return;
            const parseData: IBanner = JSON.parse(data.jsonData);
            if (!parseData.isActive) return;
            this.createBanner(parseData.bannerList,parseData.bannerTitle);
        } catch (error) {
            console.log(error);
        }
    }    

    createBanner(bannerList: IBannerItem[], bannerTitle: string): void {
        const boardTopImageBannerIndex = document.querySelector('.board-top-imagebanner-index');
        if (!(boardTopImageBannerIndex instanceof Element)) return;
        
        boardTopImageBannerIndex.insertAdjacentHTML('afterbegin',`<h2 class="board-top-imagebanner-title">${bannerTitle}</h2>`);

        this.appendBannerList(
            boardTopImageBannerIndex,
            bannerList,
            `<div class="board-top-imagebanner swiper-container">
                <div class="swiper-wrapper"></div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
                <div class="swiper-pagination"></div>
            </div>`,
            '.board-top-imagebanner .swiper-wrapper'
        );
        this.setSwiper();               
    }

    appendBannerList(
        boardTopImageBannerIndex: Element,
        bannerList: IBannerItem[],
        containerElement: string,
        wrapperElement: string
    ): void {
        boardTopImageBannerIndex.insertAdjacentHTML('beforeend', containerElement);
        const bannerSwiperWrapper = document.querySelector(wrapperElement);

        bannerList.forEach((bannerItem: IBannerItem) => {
            let bannerItemElement = `
                <div class="item swiper-slide">
                    <a href="${bannerItem.url}" class="link">
                        <img src="${bannerItem.img}" class="img" alt="">
                        <span class="category">${bannerItem.category}</span>
                        <div class="title">${bannerItem.title}</div>
                    </a>
                </div>`;
            bannerSwiperWrapper?.insertAdjacentHTML('beforeend', bannerItemElement);
        });
    }

    setSwiper(): void {
        const initSwiper = () => {
            const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

            return new Swiper('.board-top-imagebanner', {
                modules: [Navigation, Pagination, Autoplay],
                roundLengths: true,
                slidesPerView: isMobile ? 1 : 3,
                slidesPerGroup: isMobile ? 1 : 3,
                spaceBetween: isMobile ? 0 : 20,
                loop: isMobile,
                autoplay: isMobile
                    ? {
                        delay: 3000,
                        disableOnInteraction: false,
                    }
                    : false,
                navigation: {
                    nextEl: '.board-top-imagebanner .swiper-button-next',
                    prevEl: '.board-top-imagebanner .swiper-button-prev',
                },
                pagination: {
                    el: '.board-top-imagebanner .swiper-pagination',
                    clickable: true,
                },
            });
        }

        // 초기화
        let swiper = initSwiper();

        // 창 크기 변경 시 Swiper 재생성
        window.addEventListener('resize', () => {           
            // const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

            swiper.destroy(true, true);
            swiper = initSwiper();
        });
    }

} // end of class
